import ListsApi from '../api/ListsApi';
import ListsConstants from '../constants/ListsConstants';

function getLists({ metadataId, page, category }) {
  return {
    types: [ListsConstants.GET_LISTS_REQUEST, ListsConstants.GET_LISTS_SUCCESS, ListsConstants.GET_LISTS_FAILURE],
    apiRequest: (state, client) => ListsApi.getLists({ metadataId, category, page, size: 10 }, client)
  };
}

export default {
  getLists
};
